package com.pincer.core.model

import com.pincer.core.model.drafts.PincerDraft

import com.pincer.core.model.tree.Pincer

class PincerPack(val local: Pincer) {

    val remote = local.copyViaJson()

    val ui = PincerDraft()

    var syncing = false

    // A sync was asked for while one was running: run another when it finishes, so nothing waits for the next change
    var syncAgain = false

    var failure: String? = null

    fun failed() = !failure.isNullOrBlank()

}